import React from 'react';

import './post.css';

import testImg from '../../assets/img/5g.jpg';

import Fancybox from "./fancybox.js";

const Post = (params) => {
  const { title, link, desc, preview, category, date, download, id } = params;
  return (
    <div className='search__post'>
      <div className='search__post-common'>
        <div className='search__post-title'>
          {category && category.isVideo && (
            <Fancybox options={{ infinite: false }}>
              <a href="javascript:;" data-fancybox={`video-${id}`} data-src={category.isVideo}>{title}</a>
            </Fancybox>
          ) || (
            <a href={link}>{title}</a>
          )}
        </div>
        <div className='search__post-desc' dangerouslySetInnerHTML={{ __html: desc }}>
        </div>
        <div className='search__post-info'>
          <div className='search__post-category'>
            
            {category && category.termsResources && ( <span className='search__post-category-item'>Ресурсы</span> )}
            {category && category.termsCategory && ( <span className='search__post-category-item'>Events</span> )}
            
            {category && category.list && (
              <>
                {category.list.map((item, index) => {
                  return (
                    <span key={index} className='search__post-category-item'>{item.name}</span>
                  )
                })}
              </>
            )}
          </div>
          <div className='search__post-date' dangerouslySetInnerHTML={{ __html: date }}></div>
        </div>
      </div>
      <div className='search__post-media'>
        {download && (
          <div className='search__post-download'>
            <a href={download.link} target="_blank" className='search__post-download-button'>{download.title}</a>
          </div>
        ) || (preview && (
          <div className='search__post-preview'>
            <a href={link}><img src={preview ? preview : testImg} /></a>
          </div>
        ))}
      </div>      
    </div>
  )
}

export default Post;